import DateUtils from '../dateUtils';

export const createDownloadCsv = (csv: Blob, filePrefix: string): void => {
  const data = csv && window.URL.createObjectURL(csv);
  const link = document.createElement('a');
  link.href = data || '';
  link.download = `truckbase-${filePrefix}-${DateUtils.getShortDate(new Date())}.csv`;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    data && window.URL.revokeObjectURL(data);
  }, 100);
};
